export default "__VITE_ASSET__CAarwGDV__";